import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { ItemRateVendorWisePopUp } from './ItemRateVendorWiseTable';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class ItemRateVendorWise extends Component {
    constructor(props) {
        super(props)
        this.masterEntryServices = new MasterEntryServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            itemObject: {
                selectedType: "CUSTOMER",
                types: [
                    {
                        value: 1,
                        label: "CUSTOMER",
                    },
                    {
                        value: 2,
                        label: "SUPPLIER",
                    },
                    {
                        value: 4,
                        label: "HO",
                    }
                ],
                idVendor: 0,
                vendorList: [],
                completeVendorList: [],
                idItemCategory: 0,
                itemCategoryList: [],
                revisionItemRowData: [],
                revisionRateColdefs: [],
                existingItemRowData: [],
                existingItemColdefs: [],
            },
            deleteExistingItemId: 0,
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                selectedType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "select type"
                        ),
                    },
                ],
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                // idItemCategory: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "item category"
                //         ),
                //     },
                // ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getbyId(event.data.idVendor, event.data.type);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    onRowDoubleClickedItemRateRevisionList = (event) => {
        this.SwalServices
            .Confirm("Delete item rate revision record", "Are you sure ?", "Okay", "Cancel")
            .then((response) => {
                if (response) {
                    this.masterEntryServices.delete_Master_ItemsRecord(event.data.idItem).then((response) => {
                        if (response.statusCode == 200 && response.responseItem !== null) {
                            this.getMasterItemSelectForRateRivision();
                            this.getMasterItemRateVendorwiseSelect2();
                            this.SwalServices.Success("Deleted Successfully.");
                        }
                        else {
                            this.SwalServices.Error(response.message);
                        }
                    });
                }
            });
    };

    onRowDoubleClickedExistingItemDetailsList = (event) => {
        this.SwalServices
            .Confirm("Delete existing item details record", "Are you sure ?", "Okay", "Cancel")
            .then((response) => {
                if (response) {
                    this.masterEntryServices.deleteMasterItemsExistingItemRecord(event.data.idItemRateVendor).then((response) => {
                        if (response.statusCode == 200 && response.responseItem !== null) {
                            this.getMasterItemSelectForRateRivision();
                            this.getMasterItemRateVendorwiseSelect2();
                            this.SwalServices.Success("Deleted Successfully.");
                        }
                        else {
                            this.SwalServices.Error(response.message);
                        }
                    });
                }
            });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idVendor);
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
            this.clear();
        });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, }, () => {
            this.clear();
        });
    };

    handleChange = (event, name) => {
        let value = event.value;
        let details = this.state.itemObject;
        if (name === 'selectedType') {
            details.selectedType = event.label;
        } else {
            details[name] = value;
        }
        this.setState({ itemObject: details }, () => {
            if (name === 'idVendor') {
                this.getMasterItemSelectForRateRivision();
                this.getMasterItemRateVendorwiseSelect2();
            } else if (name === "selectedType") {
                this.manageTypeSelection(this.state.itemObject.revisionItemRowData);
                this.usp_Master_PartyAccountSelect(event.label)
            }
        });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let itemObject = this.state.itemObject;
        itemObject.processNo = "";
        itemObject.processName = "";
        itemObject.processDesc = "";
        itemObject.remarks = "";
        this.setState({
            itemObject: itemObject, validState: validState
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownForStockMaster();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Item Rate Vendor wise",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: [""].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                        }, () => {
                            // let obj = this.state.itemObject;
                            // obj.vendorList = data;
                            // obj.vendorList.map((x) => {
                            //     x.value = x.idVendor;
                            //     x.label = x.vendor;
                            // });
                            // this.setState({ itemObject: obj })
                            this.usp_Master_PartyAccountSelect('CUSTOMER')
                            this.procSelectAllRecord2GridviewSP(id);
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    usp_Master_PartyAccountSelect = (type) => {
        let request = [this.state.idCompany, this.state.itemObject.idVendor]
        this.masterEntryServices.usp_Master_PartyAccountSelectForVendors(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        type: x.type
                    }));
                    let obj = this.state.itemObject;
                    obj.vendorList = dynamicData.filter((x) => x.type === type);
                    obj.completeVendorList = dynamicData
                    this.setState({ itemObject: obj })
                }
            }
        });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "idVendor": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.65,

            "drawingNo": window.innerWidth * 0.2,
            "itemCategory": window.innerWidth * 0.2,
            "itemName": window.innerWidth * 0.2,
            "actualRate": window.innerWidth * 0.06,
            "vendor Rate": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "select": window.innerWidth * 0.05,
            "searchText": window.innerWidth * 0.08,
            "itemCategory": window.innerWidth * 0.1,
            "drawingNo": window.innerWidth * 0.12,
            "itemName": window.innerWidth * 0.2,
            "rate": window.innerWidth * 0.06,
            "actualRate": window.innerWidth * 0.06,
            "purchaseRate": window.innerWidth * 0.06,
            "startDate": window.innerWidth * 0.08,
            "endDate": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getColumnWidth3 = (key) => {
        const colwidth = {
            "select": window.innerWidth * 0.05,
            "searchText": window.innerWidth * 0.1,
            "itemCategory": window.innerWidth * 0.1,
            "itemCategoryDesc": window.innerWidth * 0.1,
            "drawingNo": window.innerWidth * 0.12,
            "itemName": window.innerWidth * 0.25,
            "rate": window.innerWidth * 0.06,
            "stockRate": window.innerWidth * 0.06,
            "actualRate": window.innerWidth * 0.06,
            "purchaseRate": window.innerWidth * 0.06,
            "startDate": window.innerWidth * 0.08,
            "endDate": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Item Rate Vendor wise",
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: []
                        });
                    }
                }
            });
        }
    };

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                data.itemCategoryList = allData.filter(item => item.source === 'All_Master_ItemCategory');
                data.itemCategoryList.map((x) => {
                    x.label = x.label + ' - ' + x.name2
                });
                this.setState({
                    itemObject: data,
                });
            }
        });
    }

    getMasterItemSelectForRateRivision = () => {
        let request = [this.state.idCompany, this.state.itemObject.idVendor, this.state.itemObject.idItemCategory];
        this.masterEntryServices.getMasterItemSelectForRateRivision(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.manageTypeSelection(data);
            }
        });
    }

    getMasterItemRateVendorwiseSelect2 = () => {
        this.masterEntryServices.getMasterItemRateVendorwiseSelect2(this.state.itemObject.idVendor).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.itemObject;
                if (data.length > 0) {
                    // data.map((x, key) => {
                    //     x.costingRate = x.stockRate;
                    //     x.actualRate = x.itemRate;
                    // });
                    const columnPriority = [
                        "srNo", "Select", "drawingNo", "itemCategory", "itemName",
                        "unitDescription", "opStockDate", "opStock", "rejectionStock",
                        "status", "isApproved",
                    ];

                    const allKeys = Object.keys(data[0]);
                    const sortedKeys = allKeys.sort((a, b) => {
                        const indexA = columnPriority.indexOf(a);
                        const indexB = columnPriority.indexOf(b);
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });

                    const dynamicData = sortedKeys.map((key) => ({
                        field: key.includes(".") ? key.replace(/\./g, "_") : key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                        flex: 1,
                        filter: true,
                        floatingFilter: true,
                        hide: ["idItemRateVendor"].includes(key) ? true : false,
                        width: this.getPinnedWidth(key),
                        editable: key === "rate",
                        valueParser: key === "rate" ? (params) => Number(params.newValue) : undefined,
                        valueFormatter: key.includes("startDate", "endDate")
                            ? (params) => {
                                if (!params.value) return "";
                                return moment(params.value).format("DD-MM-YYYY");
                            }
                            : undefined,
                    }));
                    itemObject.existingItemRowData = data;
                    itemObject.existingItemColdefs = dynamicData;
                    this.setState({
                        itemObject: itemObject
                    });
                } else {
                    itemObject.existingItemRowData = [];
                    itemObject.existingItemColdefs = [];
                    this.setState({
                        itemObject: itemObject
                    });
                }
            }
        });
    }

    manageTypeSelection = (data) => {
        let itemObject = this.state.itemObject;

        if (data.length > 0) {
            data.map((x, key) => {
                x.Select = false
                x.costingRate = x.stockRate;
                x.actualRate = x.itemRate;
                x.rate = 0;
            });
            const columnPriority = [
                "Select", "drawingNo", "searchText", "itemName", "actualRate", "rate", "purchaseRate",
            ];

            const allKeys = Object.keys(data[0]);
            const sortedKeys = allKeys.sort((a, b) => {
                const indexA = columnPriority.indexOf(a);
                const indexB = columnPriority.indexOf(b);
                if (indexA === -1 && indexB === -1) return 0;
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });

            const dynamicData = sortedKeys.map((key) => {
                const isSelectColumn = key === "Select";
                const isRateColumn = key === "rate";

                return {
                    field: key.includes(".") ? key.replace(/\./g, "_") : key,
                    headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                    minWidth: this.getColumnWidth3(key) !== undefined
                        ? this.getColumnWidth3(key)
                        : window.innerWidth * 0.06,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                    hide: itemObject.selectedType === "CUSTOMER"
                        ? ["idItem", "purchaseRate", "itemRate", "jobWorkRate"].includes(key)
                        : ["idItem", "costingRate", "itemRate", "jobWorkRate"].includes(key),
                    width: this.getPinnedWidth(key),
                    valueGetter: (params) => params.data[key],
                    editable: isRateColumn,
                    ...(isSelectColumn && {
                        //Render checkbox in cell, not for row selection
                        cellRenderer: 'agCheckboxCellRenderer',
                        editable: true,
                    }),
                };
            });
            itemObject.revisionItemRowData = data;
            itemObject.revisionRateColdefs = dynamicData;

            this.setState({ itemObject: itemObject });
        } else {
            itemObject.revisionItemRowData = [];
            itemObject.revisionRateColdefs = [];

            this.setState({ itemObject: itemObject });
        }
    };

    clear = () => {
        let data = this.state.itemObject;
        data.selectedType = "CUSTOMER";
        data.idVendor = 0;
        data.idItemCategory = 0;
        data.revisionItemRowData = [];
        data.revisionRateColdefs = [];
        data.existingItemRowData = [];
        data.existingItemColdefs = [];
        this.setState({ itemObject: data, deleteExistingItemId: 0 });
    }

    save = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = [];
            let data = this.state.itemObject;
            data.revisionItemRowData.map((x) => {
                if (x.Select === true) {
                    let obj = {
                        date: new Date().toISOString(),
                        idVendor: data.idVendor,
                        idItem: x.idItem,
                        actualRate: x.actualRate,
                        rate: x.rate,
                        idCompany: this.state.idCompany,
                        e_Date: new Date().toISOString(),
                        startDate: null,
                        endDate: null,
                    };
                    request.push(obj);
                }
            });
            if (request.length > 0) {
                this.masterEntryServices.saveMasterItemRateVendorwiseInsert(request).then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        this.setState({
                            isModalOpen: false
                        }, () => {
                            this.SwalServices.Success("Save successfully.");
                        });
                    }
                });
            }
        }
    }

    update = () => {
        let request = [];
        let data = this.state.itemObject;
        data.existingItemRowData.map((x) => {
            // if (x.Select === true) {
            let obj = {
                idItemRateVendor: x.idItemRateVendor,
                actualRate: x.actualRate,
                rate: x.rate,
                startDate: x.startDate,
                endDate: x.endDate,
            };
            request.push(obj);
            // }
        });
        if (request.length > 0) {
            this.masterEntryServices.saveMasterItemRateVendorwiseUpdate(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    this.SwalServices.Success("Updated successfully.");
                }
            });
        }
    }

    getbyId = (id, type) => {
        let data = this.state.itemObject;
        data.idVendor = id;
        data.selectedType = type;
        data.idItemCategory = 0;
        this.setState({ itemObject: data, isModalOpen: true }, () => {
            this.getMasterItemSelectForRateRivision();
            this.getMasterItemRateVendorwiseSelect2();
            this.usp_Master_PartyAccountSelect(this.state.itemObject.selectedType);
        });
    }

    // handleCellClickItemListOfExistingItem = (event) => {
    //     this.setState({ deleteExistingItemId: event.data.idItemRateVendor });
    // };

    delete = () => {
        if (this.state.deleteExistingItemId > 0) {
            this.masterEntryServices.deleteItemRateVendorwiseDelete2(this.state.deleteExistingItemId).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let obj = this.state.itemObject;

                    var filterList = obj.existingItemRowData.filter(item => item.idItemRateVendor !== this.state.deleteExistingItemId);
                    if (filterList.length > 0) {
                        obj.existingItemRowData = filterList;
                    } else {
                        obj.existingItemRowData = [];
                    }
                    this.setState({ deleteExistingItemId: 0, itemObject: obj }, () => {
                        this.SwalServices.Success("Deleted successfully.");
                    })
                }
            });
        } else {
            this.SwalServices.Warning("Select item fist.");
        }
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <ItemRateVendorWisePopUp
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            itemObject={this.state.itemObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.getMasterItemSelectForRateRivision.bind(this)}
                            validState={this.state.validState}
                            clear={this.clear.bind(this)}
                            save={this.save.bind(this)}
                            update={this.update.bind(this)}
                            delete={this.delete.bind(this)}
                            rowSelection="multiple"
                            onRowClicked={this.onRowClicked}
                            onCellValueChanged={this.onCellValueChanged}
                            //handleCellClickItemListOfExistingItem={this.handleCellClickItemListOfExistingItem}
                            onRowDoubleClickedItemRateRevisionList={this.onRowDoubleClickedItemRateRevisionList}
                            onRowDoubleClickedExistingItemDetailsList={this.onRowDoubleClickedExistingItemDetailsList}
                            deleteExistingItemId={this.state.deleteExistingItemId}

                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[58vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item rate vendor wise</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
